import React from "react";
import { EuiTab, EuiTabs } from "@elastic/eui";
import { createUseStyles } from "react-jss";
import { COLORS } from "Consts";

const useTabStyles = createUseStyles({
  tab: {
    "& .euiTab__content": {
      color: COLORS.$euiColorMediumShade + "!important",
    },
    "&.euiTab-isSelected .euiTab__content": {
      color: "var(--button-bg) !important;",
    },
    cursor: "pointer",
  },
});

export interface FDTopTabItem {
  label: string;
  path: string;
  permissions?: any[];
  subItems?: any[];
}

export interface TopTabsProps {
  items: FDTopTabItem[];
  onTabClick: (item: FDTopTabItem) => void;
  isTabSelected: (item: FDTopTabItem) => boolean;
  className?: string;
  tabClassName?: string;
  bottomBorder?: boolean;
  selectedTabCSS?: any;
}

const TopTabs: React.FC<TopTabsProps> = ({
  items = [],
  onTabClick,
  isTabSelected,
  className,
  tabClassName,
  bottomBorder = true,
  selectedTabCSS = { boxShadow: "inset 0 -2px 0 var(--button-bg)" },
}) => {
  const classes = useTabStyles();
  const hasItems = items.length > 0;

  const renderTabs = () => {
    if (!hasItems) {
      return (
        <EuiTab
          color="text"
          key="placeholdertab"
          onClick={() => {}}
          style={{ visibility: "hidden" }}>
          placeholdertab
        </EuiTab>
      );
    }

    return items.map((item, index) => {
      const isSelected = isTabSelected(item);

      return (
        <EuiTab
          color="text"
          className={classes.tab}
          isSelected={isSelected}
          css={isSelected ? selectedTabCSS : { boxShadow: "inset 0 -0.5px 0 var(--border-color)" }}
          key={`${item.path}_${item.label}_${index}`}
          onClick={() => onTabClick(item)}>
          {item.label}
        </EuiTab>
      );
    });
  };

  return (
    <EuiTabs
      bottomBorder={bottomBorder}
      style={
        bottomBorder
          ? {
              borderBottom: "1px solid var(--border-color)",
            }
          : {}
      }
      className={className}>
      {renderTabs()}
    </EuiTabs>
  );
};

export default TopTabs;
